module.exports = "/images/bg.svg";